import { useCallback, useEffect, useMemo } from "react";
import { Theme, useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { useAtomicStyles } from "styles";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "redux-store";
import { useCurrentMerchantId } from "../../hooks";
import { selectors } from "../../redux-store/slices/merchant";
import { LimitationType } from "../../redux-store/slices/merchant/interfaces";
import { getAjaxIsLoadingByApi } from "../../redux-store/slices/ajax/selectors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    datagridButton: {
      marginTop: 0,
      marginRight: 10,
    },
  }),
);

const useEventsToolbar = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const merchantId = useCurrentMerchantId();
  const usages = useSelector(selectors.getMerchantUsages);
  const isLoading = useSelector(
    getAjaxIsLoadingByApi(actions.getMerchantsUsagesByMerchantId.api),
  );
  const dispatch = useDispatch();

  const handleCreateEventDialogOpen = useCallback(() => {
    dispatch(actions.setIsCreateEventDialogOpen(true));
  }, [dispatch]);

  useEffect(() => {
    dispatch(actions.getMerchantsUsagesByMerchantId.request({ merchantId }));
  }, [dispatch, merchantId]);

  const data = useMemo(() => {
    if (usages) {
      const data = {
        isDisabled: false,
        message: "",
      };
      usages.forEach((u) => {
        if (u.limitation.type === LimitationType.Event) {
          if (u.currentValue >= u.limitation.threshold) {
            data.isDisabled = true;
            data.message =
              "Hai superato il limite di eventi consentito dal tuo piano di abbonamento";
          }
        } else if (u.limitation.type === LimitationType.Device) {
          if (u.currentValue >= u.limitation.threshold) {
            data.isDisabled = true;
            data.message =
              "Hai superato il limite di device consentito dal tuo piano di abbonamento";
          }
        }
      });
      return data;
    }
  }, [usages]);

  return {
    styles,
    classes,
    atomicStyles,
    handleCreateEventDialogOpen,
    data,
    isLoading,
  };
};

export { useEventsToolbar as default };
